<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="header-row">
          <div class="header-action">
            <!-- New Button -->
            <app-button variant="filled" (click)="createForm()" *hasPermission="'form.create'"
              data-testid="new-form-button">
              <app-icon name="plus" /> {{ 'form.list.new' | translate }}
            </app-button>

          </div>
        </div>
      </app-card-title>
    </app-card-header>

    <app-card-content>
      <!-- Entity List Selector in inline mode -->
      <app-entity-list-selector entityType="forms" mode="single" [showActions]="false" (edit)="handleEdit($event)" />
    </app-card-content>
  </app-card>
</div>